import { custodiansApi } from 'apiConnector/custodians';
import type { Custodian } from 'models/custodian';
import { ofType } from 'redux-observable';
import type { Observable, SchedulerLike } from 'rxjs';
import { of } from 'rxjs';
import { catchError, mergeMap, timeoutWith } from 'rxjs/operators';
import type { EpicWithThunk } from 'state/state.common';
import {
  tradeAllocationCustodiansReloaded,
  tradeAllocationCustodiansReloadFailed,
} from 'state/tradeAllocationForm/tradeAllocationForm.actions';

export interface FetchCustodiansApi {
  fetchCustodians(clientId: string): Observable<Custodian[]>;
}
export function fetchTradeAllocationCustodiansEpic(
  timeoutInMillis: number = 60000,
  appScheduler?: SchedulerLike,
): EpicWithThunk {
  return (action$, _state$, { httpClient }) =>
    action$.pipe(
      ofType('TRADE_ALLOCATION_CLIENT_CHANGED'),
      mergeMap(({ tabId, client }) => {
        if (client === null) {
          return of(tradeAllocationCustodiansReloaded(tabId, []));
        }
        return custodiansApi(httpClient)
          .fetchCustodians(client!.id)
          .pipe(
            mergeMap(custodians => of(tradeAllocationCustodiansReloaded(tabId, custodians))),
            catchError(() => of(tradeAllocationCustodiansReloadFailed(tabId, 'could not retrieve custodians'))),
            timeoutWith(timeoutInMillis, of(tradeAllocationCustodiansReloadFailed(tabId, 'TIMEOUT')), appScheduler),
          );
      }),
    );
}
